import { render, staticRenderFns } from "./image.vue?vue&type=template&id=5ebed95d&scoped=true&"
import script from "./image.vue?vue&type=script&lang=js&"
export * from "./image.vue?vue&type=script&lang=js&"
import style0 from "./image.vue?vue&type=style&index=0&id=5ebed95d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebed95d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ebed95d')) {
      api.createRecord('5ebed95d', component.options)
    } else {
      api.reload('5ebed95d', component.options)
    }
    module.hot.accept("./image.vue?vue&type=template&id=5ebed95d&scoped=true&", function () {
      api.rerender('5ebed95d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/image.vue"
export default component.exports